import fetchWithAuth from './fetchWithAuth';

const API = process.env.REACT_APP_BACKEND_URL;
const getToken = () => localStorage.getItem('access_token');
const authHeaders = () => ({
  Authorization: `Bearer ${getToken()}`,
  'Content-Type': 'application/json',
});

export const processLibraryService = {
  async listProcesses({ domain, category, status, isSpecial, search, skip = 0, limit = 100 } = {}) {
    const params = new URLSearchParams();
    if (domain) params.set('domain', domain);
    if (category) params.set('category', category);
    if (status) params.set('status', status);
    if (isSpecial !== undefined && isSpecial !== null) params.set('is_special', isSpecial);
    if (search) params.set('search', search);
    params.set('skip', skip);
    params.set('limit', limit);
    const res = await fetchWithAuth(`${API}/api/v1/process-library/processes?${params}`, { headers: authHeaders() });
    if (!res.ok) throw new Error('Failed to fetch processes');
    return res.json();
  },

  async getProcess(code) {
    const res = await fetchWithAuth(`${API}/api/v1/process-library/processes/${code}`, { headers: authHeaders() });
    if (!res.ok) throw new Error('Failed to fetch process');
    return res.json();
  },

  async createProcess(data) {
    const res = await fetchWithAuth(`${API}/api/v1/process-library/processes`, {
      method: 'POST', headers: authHeaders(), body: JSON.stringify(data),
    });
    if (!res.ok) { const e = await res.json(); throw new Error(e.detail || 'Create failed'); }
    return res.json();
  },

  async updateProcess(code, data) {
    const res = await fetchWithAuth(`${API}/api/v1/process-library/processes/${code}`, {
      method: 'PATCH', headers: authHeaders(), body: JSON.stringify(data),
    });
    if (!res.ok) { const e = await res.json(); throw new Error(e.detail || 'Update failed'); }
    return res.json();
  },

  async deleteProcess(code) {
    const res = await fetchWithAuth(`${API}/api/v1/process-library/processes/${code}`, {
      method: 'DELETE', headers: authHeaders(),
    });
    if (!res.ok) { const e = await res.json(); throw new Error(e.detail || 'Delete failed'); }
    return res.json();
  },

  async getStats(domain) {
    const params = domain ? `?domain=${domain}` : '';
    const res = await fetchWithAuth(`${API}/api/v1/process-library/stats${params}`, { headers: authHeaders() });
    if (!res.ok) throw new Error('Failed to fetch stats');
    return res.json();
  },

  async getCategories(domain) {
    const params = domain ? `?domain=${domain}` : '';
    const res = await fetchWithAuth(`${API}/api/v1/process-library/categories${params}`, { headers: authHeaders() });
    if (!res.ok) throw new Error('Failed to fetch categories');
    return res.json();
  },

  async applyToLine({ process_code, bom_id, revision_id, line_id }) {
    const res = await fetchWithAuth(`${API}/api/v1/process-library/apply-to-line`, {
      method: 'POST', headers: authHeaders(),
      body: JSON.stringify({ process_code, bom_id, revision_id, line_id }),
    });
    if (!res.ok) { const e = await res.json(); throw new Error(e.detail || 'Apply failed'); }
    return res.json();
  },
};
